import './SidebarProfileConfigurationConfig';
import { TFunction } from 'i18next';

import PencilRulerIcon from '../../../components/icons/svg/PencilRulerIcon';
import PersonIcon from '../../../components/icons/svg/PersonIcon';
import { PATH_DASHBOARD_STUDENT } from '../../../routes/paths';

interface IItemAttributes {
  title: string;
  path: string;
  icon: JSX.Element;
}

interface IItemsConfiguration {
  items: IItemAttributes[];
}

const SidebarProfileConfiguration = (t: TFunction): IItemsConfiguration[] => [
  {
    items: [
      { title: t('PERSONAL'), path: PATH_DASHBOARD_STUDENT.profile.information, icon: <PersonIcon /> },
      { title: t('SKILLS'), path: PATH_DASHBOARD_STUDENT.profile.skills, icon: <PencilRulerIcon /> },
    ],
  },
];

export default SidebarProfileConfiguration;
